import React, { useState } from "react";
import {
  Dialog,
  Button,
  InputBase,
  CircularProgress,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DeleteRouteModal = ({
  open,
  setOpen,
  routeName ,
  deleteRoute,
  loading = false,
}) => {
  const [confirmText, setConfirmText] = useState("");

  const isConfirmed = confirmText === routeName;

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "14px",
          padding: "28px",
        },
      }}
      BackdropProps={{
        style: { backgroundColor: "rgba(0,0,0,0.35)" },
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-start mb-4">
        <h2 className="text-[22px] font-semibold text-red-600">
          Delete Route
        </h2>
        <CloseIcon
          className="cursor-pointer text-gray-400"
          onClick={() => setOpen(false)}
        />
      </div>

      {/* Description */}
      <p className="text-gray-600 text-[15px] leading-relaxed mb-3">
        This action cannot be undone. To confirm deletion, please type the route
        name:{" "}
        <span className="font-semibold text-gray-800">
          {routeName}
        </span>
      </p>

      {/* Input */}
      <InputBase
        placeholder="Enter route name to confirm"
        value={confirmText}
        onChange={(e) => setConfirmText(e.target.value)}
        sx={{
          width: "100%",
          border: "1px solid #D1D5DB",
          borderRadius: "10px",
          padding: "4px 8px",
          fontSize: "15px",
          mb: 4,
        }}
      />

      {/* Actions */}
      <div className="flex justify-end gap-3">
        <Button
          variant="outlined"
          onClick={() => setOpen(false)}
          sx={{
            textTransform: "none",
            borderRadius: "10px",
            px: 3,
            py: 0.4,
            fontSize: "15px",
            color: "#374151",
            borderColor: "#D1D5DB",
          }}
        >
          Cancel
        </Button>

        <Button
          disabled={!isConfirmed || loading}
          onClick={deleteRoute}
          sx={{
            textTransform: "none",
            borderRadius: "10px",
            px: 3,
            py: 0.4,
            fontSize: "15px",
            fontWeight: 600,
            bgcolor: "#FCA5A5",
            color: "#fff",
            "&:hover": { bgcolor: "#EF4444" },
            "&.Mui-disabled": {
              bgcolor: "#FBCACA",
              color: "#fff",
            },
          }}
        >
          {loading ? (
            <CircularProgress size={20} sx={{ color: "#fff" }} />
          ) : (
            "Delete Route"
          )}
        </Button>
      </div>
    </Dialog>
  );
};

export default DeleteRouteModal;
